import React from 'react';

const Pagination = ({ currentPage, hasPreviousPage, hasNextPage, goToPreviousPage, goToNextPage }) => {
  return (
    <div className="flex justify-center mt-6 mb-6 space-x-4 py-3 border-t border-b border-gray-200">
      <button
        onClick={goToPreviousPage}
        disabled={!hasPreviousPage}
        className={`px-6 py-2 rounded-md font-medium ${
          hasPreviousPage
            ? 'bg-blue-600 text-white hover:bg-blue-700 shadow-md'
            : 'bg-gray-200 text-gray-500 cursor-not-allowed'
        }`}
      >
        ← Previous
      </button>
      <span className="px-4 py-2 text-gray-700 font-bold">
        Page {currentPage}
      </span>
      <button
        onClick={goToNextPage}
        disabled={!hasNextPage}
        className={`px-6 py-2 rounded-md font-medium ${
          hasNextPage
            ? 'bg-blue-600 text-white hover:bg-blue-700 shadow-md'
            : 'bg-gray-200 text-gray-500 cursor-not-allowed'
        }`}
      >
        Next →
      </button>
    </div>
  );
};

export default Pagination;
